module.exports = __webpack_public_path__ + "media/icons/player2-2f1fb2b0.png";